// extracted by mini-css-extract-plugin
export var alpha = "_il-4";
export var alphaInputContainer = "_il-j";
export var badge = "_il-b";
export var brandKitGrid = "_il-l";
export var brandKitItem = "_il-m";
export var brandKitSwatch = "_il-n";
export var controls = "_il-5";
export var formatDropdown = "_il-h";
export var formatSelector = "_il-g";
export var hex = "_il-6";
export var hexInput = "_il-i";
export var hue = "_il-3";
export var hueAndAlphaPointer = "_il-a";
export var percentageLabel = "_il-k";
export var picker = "_il-0";
export var rgba = "_il-8";
export var rgbaSection = "_il-7";
export var saturation = "_il-1";
export var saturationPointer = "_il-9";
export var sliders = "_il-2";
export var swatch = "_il-c";
export var swatchDisabled = "_il-f";
export var swatchRing = "_il-d";
export var swatchTransparent = "_il-e";